module.exports = __webpack_public_path__ + "static/media/list_group.8bf2122f.svg";